import { LoginStatusTypes } from '../enums/login-status-types.enum';
import { Employee } from './employee.model';
import { Representative } from './representative.model';

export interface LoginResponse {
  $id: number;
  jwt: string;
  clientAccessId: string;
  loginStatus: LoginStatusTypes;
  employee?: Employee | null;
  representative?: Representative | null;
  isTCPending: boolean;
  responseMessages: ResponseMessages;
}

export interface ResponseMessages {
  $id: number;
  $values: string[];
}
